module.exports = __webpack_public_path__ + "img/roles-logo-active.0d318e59.svg";